import { jsx } from 'react/jsx-runtime';
import { useState, useRef, useEffect, useCallback } from 'react';
import Moveable from 'react-moveable';
import { styled } from 'styled-components';

const StyledMoveable = styled(Moveable).withConfig({
  displayName: "Resizer__StyledMoveable",
  componentId: "sc-43c30d7a-0"
})([
  `--moveable-color:rgba(var(--color-primary),1) !important;.moveable-line{display:none !important;}`
]);
const Resizer = ({ editor }) => {
  const [activeElement, setActiveElement] = useState(null);
  const moveableRef = useRef(null);
  useEffect(() => {
    const handler = ({ editor: editor2 }) => {
      const element = editor2.view.dom.querySelector(".ProseMirror-selectednode");
      const resizeable = element?.querySelector("[data-resizeable]");
      if (!resizeable || !(resizeable instanceof HTMLElement)) {
        setActiveElement(null);
        return;
      }
      setActiveElement(resizeable);
    };
    const handleChanges = () => {
      moveableRef.current?.updateRect();
    };
    const onScroll = () => {
      moveableRef.current?.updateRect();
    };
    editor.on("selectionUpdate", handler);
    editor.on("transaction", handleChanges);
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("wheel", onScroll, true);
    return () => {
      editor.off("selectionUpdate", handler);
      editor.off("transaction", handleChanges);
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("wheel", onScroll, true);
    };
  }, [
    editor
  ]);
  const updateSize = useCallback((width) => {
    if (!activeElement) return;
    const pos = editor.view.posAtDOM(activeElement, 0);
    const activeNode = editor.state.doc.nodeAt(pos);
    if (!activeNode) return;
    editor.chain().focus().updateAttributes(activeNode.type.name, {
      width,
      height: "auto"
    }).setNodeSelection(pos).run();
  }, [
    editor,
    activeElement
  ]);
  if (!activeElement) return null;
  return /* @__PURE__ */ jsx(StyledMoveable, {
    ref: moveableRef,
    target: activeElement,
    useAccuratePosition: true,
    container: null,
    origin: false,
    edge: false,
    useResizeObserver: true,
    useMutationObserver: true,
    keepRatio: true,
    resizable: true,
    throttleResize: 0,
    /**
    * for some reason the onResize event is not being triggered
    * when enlarging the element, only when shrinking
    *
    * https://github.com/daybrush/moveable/blob/master/handbook/handbook.md#event-sequences-ex-draggable
    * beforeRender => beforeResize => resize => render
    *
    * event doesn't appear cancelled, stoped etc.
    *
    * so we manually set the size and update the rect
    * here in the onBeforeResize event
    */
    onBeforeResize: ({ target, boundingWidth, boundingHeight, ...rest }) => {
      target.style.width = `${boundingWidth}px`;
      target.style.height = `auto`;
      rest.moveable.updateRect();
      rest.setSize([
        boundingWidth,
        boundingHeight
      ]);
    },
    // onResize={({ target, width, delta, ...e }) => {
    //   delta[0] && (target.style.width = `${width}px`);
    //   delta[1] && (target.style.height = `auto`);
    // }}
    onResizeEnd: ({ target }) => {
      const width = parseInt(target.style.width);
      updateSize(width);
    },
    // render left and right center handles
    renderDirections: [
      "w",
      "e"
    ]
  });
};

export { Resizer as default };
//# sourceMappingURL=Resizer.js.map
